import { backendUrl } from "../backendUrl";
import React, { ChangeEvent, useEffect, useState } from "react";
import { createEnumDeclaration } from "typescript";
import ReactSlider from "react-slider";
import { Box, Slider } from "@mui/material";
import "./style.css";
import axios from "axios";
import { TIMEOUT } from "dns";
// import { apiServer } removed


interface SortProps {
  configuration: ConfigurationDetail;
  configurationOriginal: ConfigurationDetail;
  onConfigurationChange: (newConfig: ConfigurationDetail) => void;
  sort: String;
  price: Price;
}
interface ConfigurationDetail {
  filteredResult: Configuration[];
  maxValue: string;
  minValue: string;
}
interface Configuration {
  supllier: string;
  system1: string;
  price: number;
}
interface SystemInfo {
  supllier: string;
  system1: string;
  slogan: string;
  specialfeature: string;
  patentprotection: number;
}

interface Price {
  minPrice: string;
  maxPrice: string;
}

interface Supplier {
  id: number;
  name: string;
  icon_path: string;
  display_order: number;
  is_active: number;
}

const Sort: React.FC<SortProps> = ({
  configuration,
  configurationOriginal,
  onConfigurationChange,
  sort,
  price,
}) => {
  // Detekcja urządzeń mobilnych (spójnie z ChooseLockSystem)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const detectMobile = () => {
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isMobileScreen = window.innerWidth < 960; // zwiększony breakpoint
      
      return isTouchDevice && (isMobileUserAgent || isMobileScreen);
    };

    const handleResize = () => {
      setIsMobile(detectMobile());
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  const [isInitialized, setIsInitialized] = useState(false);
  const getDataFromSession = (key: string, defaultValue: any) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : defaultValue;
  };
  const doors = getDataFromSession("doors", []);
  const keys = getDataFromSession("keys", []);
  const [tableData, setTableData] = useState<SystemInfo[]>([]);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [selectedManufacturer, setSelectedManufacturer] = useState<string>("");
  const [openManufacturerList, setOpenManufacturerList] =
    useState<boolean>(false);

  const [value, setValue] = useState<number[]>([
    parseFloat(price.minPrice) || 0,
    parseFloat(price.maxPrice) || 0,
  ]);

  // Fetch suppliers from database
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/v1/configurator/suppliers/active`);
        if (response && response.data) {
          setSuppliers(response.data);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania dostawców:", error);
      }
    };

    fetchSuppliers();
  }, []);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${apiServer}/api/v1/configurator/systemsInfo`
    //     );
    //     setTableData(response.data);
    //   } catch (error) {
    //     console.error("Błąd podczas pobierania danych:", error);
    //   }
    //   try {
    //     const response = await axios.post(
    //       `${apiServer}/api/v1/configurator/configuration?supllierFilter=${selectedManufacturer}&minPrice=${value[0]}&maxPrice=${value[1]}`,
    //       [{ doors, keys }]
    //     );
    //     onConfigurationChange({
    //       ...configuration,
    //       filteredResult: response.data.filteredResult,
    //     });
    //   } catch (error) {
    //     console.error("Błąd podczas pobierania danych:", error);
    //   }
    // };
   
    if (!isInitialized && price.minPrice && price.maxPrice) {
      setValue([parseFloat(price.minPrice), parseFloat(price.maxPrice)]);
      setIsInitialized(true); // Oznacz wartości jako zainicjalizowane
    }
    const filterData = async () => {
      // Jeśli zakres jest domyślny (pełny), zwróć całą listę
      const min = parseFloat(price.minPrice);
      const max = parseFloat(price.maxPrice);
      if (
        value[0] === min && value[1] === max && selectedManufacturer === ""
      ) {
        return configurationOriginal.filteredResult;
      }
      let data;
      if (selectedManufacturer !== "") {
        data = configurationOriginal.filteredResult.filter(
          (el) =>
            el.supllier === selectedManufacturer &&
            el.price >= value[0] &&
            el.price <= value[1]
        );
      } else {
        data = configurationOriginal.filteredResult.filter(
          (el) => el.price >= value[0] && el.price <= value[1]
        );
      }
      return data;
    };

    // Debounce: wywołaj onConfigurationChange dopiero po 100ms od ostatniej zmiany
    const handler = setTimeout(() => {
      filterData().then((data) =>
        onConfigurationChange({
          ...configuration,
          filteredResult: data,
        })
      );
    }, 100);
    return () => clearTimeout(handler);
  }, [value, selectedManufacturer, sort, price.minPrice, price.maxPrice, isInitialized]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${backendUrl}/api/v1/configurator/systemsInfo`
        );
        setTableData(response.data);
      } catch (error) {
        console.error("Błąd podczas pobierania danych:", error);
      }
    };
    fetchData();
    if (value[0] === 0 || value[1] === 0) {
      setValue([Number(price.minPrice), Number(price.maxPrice)]);
    }
  }, []);
  useEffect(() => {
    if (
      value[0] < Number(price.minPrice) ||
      value[1] > Number(price.maxPrice)
    ) {
      setValue([Number(price.minPrice), Number(price.maxPrice)]);
    }
  }, [sort]);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number[]);
  };

  const handleChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const index = event.target.name === "min" ? 0 : 1;
    const newValue = event.target.value
      ? parseFloat(event.target.value)
      : value[index]; // Użyj bieżącej wartości zamiast resetować
    const clampedValue = Math.min(Math.max(newValue, 0), 1076);

    const updatedValue = [...value];
    updatedValue[index] = clampedValue;

    if (updatedValue[0] === Infinity || updatedValue[1] === Infinity) {
      updatedValue[0] = Number(price.minPrice);
      updatedValue[1] = Number(price.maxPrice);
    }
    if (!isNaN(newValue)) {
      // Ustaw nową wartość dla odpowiedniego indeksu, zachowując drugą wartość
      let updatedValue = [...value];
      updatedValue[index] = newValue;
      setValue(updatedValue);
    }
  };

  const buttonClass = {};

  // Get unique suppliers from database, sorted by display_order
  const uniqueSuppliers = suppliers
    .sort((a, b) => a.display_order - b.display_order)
    .map((supplier) => supplier.name);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "flex-start",
        alignItems: isMobile ? "stretch" : "center",
        gap: isMobile ? "20px" : "30px",
        marginBottom: "20px",
        width: "100%",
        padding: isMobile ? "16px" : "20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #e9ecef"
      }}
    >
      {/* Filtr producenta */}
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        minWidth: isMobile ? "100%" : "200px",
        flex: isMobile ? "1" : "0 0 auto"
      }}>
        <label style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#495057",
          marginBottom: "8px"
        }}>
          Hersteller
        </label>
        <select
          value={selectedManufacturer}
          onChange={(e) => {
            setSelectedManufacturer(e.target.value);
            setOpenManufacturerList(false);
          }}
          style={{
            width: "100%",
            padding: "12px 16px",
            border: "2px solid #e9ecef",
            outline: "none",
            borderRadius: "8px",
            backgroundColor: "white",
            fontSize: "14px",
            color: "#495057",
            transition: "all 0.2s ease",
            cursor: "pointer"
          }}
          onFocus={(e) => e.target.style.borderColor = "#005CA9"}
          onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
        >
          <option value="">Alle Hersteller</option>
          {uniqueSuppliers.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            );
          })}
        </select>
      </div>

      {/* Filtr cenowy */}
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        flex: "1",
        minWidth: isMobile ? "100%" : "300px"
      }}>
        <label style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#495057",
          marginBottom: "8px"
        }}>
          Preisbereich
        </label>
        
        {/* Pola input dla cen */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "16px",
          flexWrap: isMobile ? "wrap" : "nowrap"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "14px", color: "#6c757d", whiteSpace: "nowrap" }}>von</span>
            <input
              type="number"
              style={{
                width: "80px",
                padding: "8px 12px",
                border: "2px solid #e9ecef",
                borderRadius: "6px",
                textAlign: "center",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s ease"
              }}
              placeholder={price.minPrice}
              value={value[0]}
              name="min"
              onChange={handleChangeInput}
              onFocus={(e) => e.target.style.borderColor = "#005CA9"}
              onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
            />
            <span style={{ fontSize: "14px", color: "#6c757d" }}>€</span>
          </div>
          
          <span style={{ fontSize: "14px", color: "#6c757d" }}>bis</span>
          
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="number"
              style={{
                width: "80px",
                padding: "8px 12px",
                border: "2px solid #e9ecef",
                borderRadius: "6px",
                textAlign: "center",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s ease"
              }}
              placeholder={price.maxPrice}
              value={value[1]}
              name="max"
              onChange={handleChangeInput}
              onFocus={(e) => e.target.style.borderColor = "#005CA9"}
              onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
            />
            <span style={{ fontSize: "14px", color: "#6c757d" }}>€</span>
          </div>
        </div>

        {/* Suwak cenowy */}
        <div style={{ 
          width: "100%",
          paddingTop: "8px"
        }}>
          <Box sx={{ 
            width: "100%",
            "& .MuiSlider-thumb": {
              backgroundColor: "#005CA9",
              border: "2px solid #ffffff",
              boxShadow: "0 2px 8px rgba(0,92,169,0.3)",
              "&:hover": {
                backgroundColor: "#004494",
                boxShadow: "0 4px 12px rgba(0,92,169,0.4)"
              }
            },
            "& .MuiSlider-track": {
              backgroundColor: "#005CA9",
              height: "6px",
              border: "none"
            },
            "& .MuiSlider-rail": {
              backgroundColor: "#e9ecef",
              height: "6px"
            },
            "& .MuiSlider-valueLabel": {
              backgroundColor: "#005CA9",
              color: "white",
              fontWeight: "600"
            }
          }}>
            <Slider
              getAriaLabel={() => "Preisbereich"}
              value={[Number(value[0]) || 0, Number(value[1]) || 0]}
              min={Number(price.minPrice) || 0}
              max={Number(price.maxPrice) || 1}
              onChange={handleChange}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value}€`}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Sort;
